module.exports = __webpack_public_path__ + "img/livechat_preview.1060a8a7.png";